import * as React from "react";
const SvgSwitchTableOval = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={21} height={22} fill="none" {...props}>
    <circle cx={10.5} cy={11} r={10.5} fill="#fff" />
  </svg>
);
export default SvgSwitchTableOval;
